import { type IPurchaseItem } from "@/interfaces/api/purchase-item.interface"
import { BaseModel } from "@/models/base.model"
import type { Units } from "@/enums/units.enum"
import { SaleItem } from "@/models/sale-item.model"
import { unitToName } from "@/helper/enums/unit-helper"
import { ModelFactory } from "@/factories/model-factory"
import { normalizeDecimal } from "@/helper/number-helper.ts"
import { KnownBusinessEntity } from "@/models/known-business-entity.model.ts"

export class PurchaseItem extends BaseModel implements IPurchaseItem {
  public static className = "PurchaseItem" // Used for socket communication.
  public static verboseName = "Inkoopartikel"

  public static override managedResolveFields = ["supplier"]

  id: string

  saleItem: SaleItem

  supplier: KnownBusinessEntity

  name: string

  unit: Units

  unitPrice: string | undefined

  conversionRate: number

  constructor(purchaseItem: IPurchaseItem, managed = false) {
    super(purchaseItem)

    this.id = purchaseItem.id
    this.saleItem = ModelFactory.childModel(SaleItem, purchaseItem.saleItem, managed)
    this.supplier = ModelFactory.childModel(KnownBusinessEntity, purchaseItem.supplier, managed)

    this.name = purchaseItem.name
    this.unit = purchaseItem.unit
    this.unitPrice = purchaseItem.unitPrice
    this.conversionRate = purchaseItem.conversionRate
  }

  public getDisplayText() {
    return `
      Inkoop ${this.name} ${this.supplier.name} ${unitToName(this.unit)}
      € ${this.unitPrice ? normalizeDecimal(this.unitPrice) : "???"}
    `
  }

  public getUnitName() {
    return unitToName(this.unit)
  }
}
